import React, { useEffect, useState } from "react";
import bell from "assets/icons/bell.png";
import Man from "assets/images/person.jpg";
import DownCaret from "assets/icons/Triangle.svg";
import { Dropdown } from "react-bootstrap";
import Avatar from "antd/lib/avatar/avatar";
import "./header.scss";
import { logout } from "service/helpers/utilities";
import SuccessIcon from "assets/images/success.png";
import NotifyModal from "../../common/Header/NotifyModal";
import { useDispatch, useSelector } from "react-redux";
import { VscThreeBars } from "react-icons/vsc";
import MobileDrawer from "./MobileDrawer";
import { history } from "helpers";
import Dashboard from "assets/icons/Dashboard.svg";
import appointment from "assets/icons/appointmentList.svg";
import activeAvailable from "assets/icons/activeAvailable.svg";
import activeSettings from "assets/icons/activeSettings.svg";
import activeProfile from "assets/icons/activeProfile.svg";
import { CgLogOut } from "react-icons/cg";
import { restrictionURL } from "action/home";

const Header = () => {
  const [adminDetails, setadminDetails] = useState({});
  const [cancelShow, setCancelShow] = useState(false);
  const [actionClick, setActionClick] = useState(false);
  const [rescheduleShow, setRescheduleShow] = useState(false);
  const [feedbackShow, setFeedbackShow] = useState(false);
  const [feedbackTitle, setFeetbackTitle] = useState("");
  const [feedbackIcon, setFeetbackIcon] = useState("");
  const [feedbackBtnName, setFeedbackBtnName] = useState("");
  const [showAvailability, setShowAvailability] = useState(false);
  const [showAvailabilityStatus, setShowAvailabilityStatus] = useState(false);
  const [openDrawer, setopenDrawer] = useState(false);
  const dispatch=useDispatch()
  const profile = useSelector((state) => state?.user?.basic);

  const [btn1, setbtn1] = useState("");
  const [btn2, setbtn2] = useState("");
  const [title, setTitle] = useState("");

  const setActionHandler = (e) => { };
  // emergencyHandler
  const notifyHandler = () => {
    setShowAvailability(true);
    setbtn1("Cancel");
    setbtn2("Submit");
    setTitle("Notifications");
  };
  const statusHandler = () => {
    setShowAvailabilityStatus(true);
    setShowAvailability(false);
  };
  const schedulerHandler = () => {
    setFeetbackTitle("Rescheduleded Successfully");
    setFeetbackIcon(<SuccessIcon />);
    setFeedbackShow(true);
    setRescheduleShow(false);
    setFeedbackBtnName("Back to Appointment List");
  };
  const confirmHandler = () => {
    setFeetbackTitle("Appointment has been Cancelled");
    setFeetbackIcon(<SuccessIcon />);
    setFeedbackShow(true);
    setCancelShow(false);
    setFeedbackBtnName("Back to Appointment List");
  };

  const drawerVisible = () => {
    setopenDrawer(true);
  };
  const navLink = [
    {
      to: "/doctor/dashboard",
      label: "Dashboard",
      iconName: Dashboard,
      activeIcon: Dashboard,
    },
  
    {
      to: `/doctor/appointment-list`,
      label: "Appointment list",
      iconName: appointment,
      activeIcon: appointment,
    },
    {
      to: "/doctor/availability",
      label: "Availability",
      iconName: activeAvailable,
      activeIcon: activeAvailable,
    },
    // {
    //   to: "/doctor/my-profile",
    //   label: "My Profile",
    //   iconName: activeProfile,
    //   activeIcon: activeProfile,
    // },
  
    // {
    //   to: "/doctor/settings",
    //   label: "Settings",
    //   iconName: activeSettings,
    //   activeIcon: activeSettings,
    // },
  
    // {
    //   to: "/doctor/consultation-view",
    //   label: "Consultation View",
    //   iconName: activeAvailable,
    //   activeIcon: activeAvailable,
    // },
  ];
  const logoutUser = () => {
    logout()
    dispatch(restrictionURL("", true))
  }
  return (
    <>
      <div className="top-bar">
        <div className="userHeader px-2 px-md-0 py-md-4 py-lg-4 py-0 my-3 my-md-0">
          <div>
            <VscThreeBars
              size={20}
              className="d-block d-md-none"
              onClick={drawerVisible}
            />
          </div>
          
          <div className="d-flex justify-content-left w-100">
             {navLink.map((items)=>{return<div className="m-3 d-flex align-items-center cursor-pointer" onClick={()=>history.push(items.to)}> <img className="" src={items.activeIcon} /> <div className="pl-2"  style={{fontSize:"18px"}}>{items.label}</div></div>}) }
             
             <div className="m-3 d-flex align-items-center cursor-pointer" onClick={logoutUser}> <CgLogOut style={{fontSize:"25px"}} /> <div className="pl-2"  style={{fontSize:"18px"}}>Logout</div></div>
          </div>
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={() => history.push("/doctor/my-profile")}
          >
            <Avatar src={profile?.profileUrl} size={50} />
            <p className="mx-2">
              {profile?.firstName} {profile?.lastName}
            </p>
            {/* <Dropdown className="custom-dropdown mt-1">
              <Dropdown.Toggle id="dropdown-basic">
                <img src={DownCaret} width={12} />
              </Dropdown.Toggle>
              <Dropdown.Menu id="drop">
                <Dropdown.Item href="#" onClick={() => logout()}>
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        </div>
        <NotifyModal
          show={showAvailability}
          onHide={() => setShowAvailability(false)}
          title={title}
          btn1={btn1}
          btn2={btn2}
          statusHandler={statusHandler}
        />
        <MobileDrawer
          visible={openDrawer}
          onClose={(data) => setopenDrawer(false)}
        />
      </div>
    </>
  );
};
export default Header;
